import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/organizations`;

// CREATE =>  POST: add a new product to the server
export function createOrganization(organization) {
    return axios.post(API_URL, { ...organization });
}

// READ
export function getAllOrganizations() {
    return axios.get(API_URL);
}

export function getPaginatedOrganizations(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getOrganizationById(organizationId) {
    return axios.get(`${API_URL}/${organizationId}`);
}



// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the organization on the server
export function updateOrganization(organizationId, organization) {
    return axios.put(`${API_URL}/${organizationId}`, { ...organization });
}


// DELETE => delete the product from the server
export function deleteOrganization(organizationId) {
    return axios.delete(`${API_URL}/${organizationId}`);
}
